import {
    AUTH_FAILED,
    AUTH_FETCHING,
    AUTH_SUCCESS,
    LOGOUT,
} from "./../../Constants.ts";

export interface AuthState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: AuthState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): AuthState => {
    switch (type) {
        case AUTH_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case AUTH_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case AUTH_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        case LOGOUT:
            return initialState;
        default:
            return state;
    }
};
